<template>
  <div class="main_div" :key="componentKey">
    <div style="height: auto">
      <n-space>
        <NCard
          style="
            margin-top: 20px;
            margin-left: 80px;
            border: 0px;
            min-width: 800px;
            max-width: 1000px;
          "
        >
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; width: auto; font-weight: bold">
              견적서 수정
            </div>
          </n-space>
          <div class="content_delimiter_line"></div>

          <Loading v-if="pageLoading" />
          <div v-else class="body_content">
            <n-form
              ref="requestFormRef"
              :model="formModel"
              :rules="editFormRules"
              label-placement="left"
              require-mark-placement="right-hanging"
            >
              <n-card title="기본 정보" style="margin-top: 20px">
                <n-descriptions
                  label-placement="left"
                  :column="1"
                  size="small"
                  bordered
                  class="org-info-descriptions"
                >
                  <n-descriptions-item label="견적명">
                    <n-form-item
                      path="name"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.name"
                        placeholder="견적명"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                </n-descriptions>
              </n-card>

              <n-card title="기관 정보" style="margin-top: 20px">
                <n-descriptions
                  v-if="formModel.client"
                  label-placement="left"
                  :column="2"
                  size="small"
                  bordered
                  class="org-info-descriptions"
                  style="margin-bottom: 10px"
                >
                  <n-descriptions-item label="기관명" span="2">{{
                    formModel.client.name || "N/A"
                  }}</n-descriptions-item>
                  <n-descriptions-item label="대표자 이름">{{
                    formModel.client.president || "N/A"
                  }}</n-descriptions-item>
                  <n-descriptions-item label="기관 유형">{{
                    common.getOrganizationTypeString(
                      formModel.client.type as OrganizationType
                    )
                  }}</n-descriptions-item>
                  <n-descriptions-item label="기관 주소" span="2"
                    >{{ formModel.client.address.address || "" }}
                    {{
                      formModel.client.address.addressDetail || ""
                    }}</n-descriptions-item
                  >
                  <n-descriptions-item label="담당부서명">
                    <n-form-item
                      path="client.dept"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.client.dept"
                        placeholder="담당부서"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                  <n-descriptions-item label="전화번호">
                    <n-form-item
                      path="client.phoneNumber"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.client.phoneNumber"
                        placeholder="010-1234-5678"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                  <n-descriptions-item label="담당자 성명">
                    <n-form-item
                      path="client.deptPersonName"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.client.deptPersonName"
                        placeholder="담당자명"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                  <n-descriptions-item label="핸드폰번호">
                    <n-form-item
                      path="client.deptPersonPhoneNumber"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.client.deptPersonPhoneNumber"
                        placeholder="010-1234-5678"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                  <n-descriptions-item label="이메일" span="2">
                    <n-form-item
                      path="client.email"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-input
                        v-model:value="formModel.client.email"
                        placeholder="contact@example.com"
                      /> </n-form-item
                  ></n-descriptions-item>
                </n-descriptions>
              </n-card>

              <n-card
                v-if="orgType == OrganizationType.Etc"
                title="검사 대상 선택"
                style="margin-top: 20px"
                content-style="text-align: left;"
              >
                <n-radio-group
                  v-model:value="selectedOrgType"
                  name="orgTypeSelection"
                >
                  <n-space>
                    <n-radio
                      :key="OrganizationType.ElementarySchool"
                      :value="OrganizationType.ElementarySchool"
                      label="초등학교"
                    />
                    <n-radio
                      :key="OrganizationType.MiddleSchool"
                      :value="OrganizationType.MiddleSchool"
                      label="증학교"
                    />
                    <n-radio
                      :key="OrganizationType.HighSchool"
                      :value="OrganizationType.HighSchool"
                      label="고등학교"
                    />
                    <n-radio
                      :key="OrganizationType.University"
                      :value="OrganizationType.University"
                      label="대학교"
                    />
                  </n-space>
                </n-radio-group>
              </n-card>

              <n-card title="검사 종류 선택" style="margin-top: 20px">
                <n-form-item path="selectedSurveySK" label-placement="left">
                  <n-radio-group
                    v-model:value="formModel.selectedSurveySK"
                    name="surveySelection"
                  >
                    <n-space>
                      <n-radio
                        v-for="survey in surveySet"
                        :key="survey.SK"
                        :value="survey.SK!"
                        :label="survey.name"
                      />
                    </n-space>
                  </n-radio-group>
                </n-form-item>
              </n-card>

              <div v-if="formModel.selectedSurveySK">
                <n-card
                  title="코칭 상품 선택 (다중 선택 가능)"
                  style="margin-top: 20px"
                >
                  <n-checkbox-group v-model:value="selectedCoachSKsForBoth">
                    <n-space item-style="display: flex;">
                      <n-checkbox
                        v-for="coach in coachSet"
                        :key="coach.SK"
                        :value="coach.SK!"
                        :label="coach.name"
                      />
                    </n-space>
                  </n-checkbox-group>
                </n-card>
              </div>
              <n-card title="신청 상품 및 수량" style="margin-top: 20px">
                <div
                  v-for="(item, index) in formModel.products"
                  :key="item.prod_id"
                  class="product-request-item"
                >
                  <n-descriptions
                    :title="item.name"
                    label-placement="left"
                    :column="3"
                    size="small"
                    bordered
                  >
                    <n-descriptions-item
                      v-if="isUniversity(item)"
                      label="학과"
                      label-placement="left"
                      style="text-align: right"
                      labelStyle="width:100px"
                    >
                      <n-input v-model:value="item.major" placeholder="학과" />
                    </n-descriptions-item>
                    <n-descriptions-item
                      label="학년"
                      label-placement="left"
                      style="text-align: right"
                      labelStyle="width:100px"
                    >
                      <n-input v-model:value="item.grade" placeholder="학년" />
                    </n-descriptions-item>
                    <n-descriptions-item
                      v-if="!isUniversity(item)"
                      label="학급수"
                      label-placement="left"
                      labelStyle="width:100px"
                    >
                      <n-input
                        v-model:value="item.class_num"
                        placeholder="학급수"
                      />
                    </n-descriptions-item>

                    <n-descriptions-item
                      label=""
                      label-placement="left"
                      labelStyle="width:100px"
                    >
                      &nbsp;
                    </n-descriptions-item>
                    <n-descriptions-item
                      label="단가(원)"
                      contentStyle="text-align: right"
                      :path="`products[${index}].unit_price`"
                      :rule="editFormRules.unitPriceRule"
                    >
                      <n-input-number
                        v-model:value="item.unit_price"
                        placeholder="단가"
                        :show-button="false"
                        :min="0"
                      />
                    </n-descriptions-item>
                    :rule="editFormRules.unitPriceRule"
                    <n-descriptions-item
                      :path="`products[${index}].quantity`"
                      :rule="editFormRules.quantityRule"
                      label="총인원수"
                    >
                      <n-input-number
                        v-model:value="item.quantity"
                        placeholder="수량"
                        :min="1"
                      />
                    </n-descriptions-item>
                    <n-descriptions-item
                      label="금액(원)"
                      contentStyle="text-align: right"
                    >
                      {{
                        common.formatNumberWithCommas(
                          Number(item.unit_price) * item.quantity
                        )
                      }}
                    </n-descriptions-item>
                  </n-descriptions>
                </div>
                <div
                  v-if="formModel.products.length > 0"
                  class="total-unit_price-section"
                >
                  <n-grid :cols="12" :x-gap="12">
                    <n-gi :span="7"></n-gi>
                    <n-gi
                      :span="5"
                      style="
                        text-align: right;
                        font-weight: bold;
                        font-size: 1.1em;
                      "
                    >
                      총 결제 금액:
                      {{ common.formatNumberWithCommas(totalPrice) }}원
                    </n-gi>
                  </n-grid>
                </div>
                <div style="margin-top: 20px">
                  <n-grid :cols="12" :x-gap="12">
                    <n-gi :span="12">
                      <n-form-item
                        label="검사 실시 예정일"
                        path="test_due_date"
                      >
                        <n-date-picker
                          v-model:formatted-value="formModel.test_due_date"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="검사 실시 예정일 선택"
                          style="width: 200px"
                        />
                      </n-form-item>
                    </n-gi>
                    <n-gi :span="12" style="padding-top: 5px">
                      <n-form-item
                        v-if="selectedCoachSKsForBoth.length > 0"
                        label="상담 코칭 예정일"
                        path="coaching_due_date"
                      >
                        <n-date-picker
                          v-model:formatted-value="formModel.coaching_due_date"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="상담 코칭 예정일 선택"
                          style="width: 200px"
                        />
                        <span style="margin-left: 10px; color: red"
                          >(일정은 검사 완료 및 결과리포트를 수령, 확인 후이어야
                          함. 042-867-5558)</span
                        >
                      </n-form-item>
                    </n-gi>
                  </n-grid>
                </div>
              </n-card>

              <n-card title="결제 정보" style="margin-top: 20px">
                <n-descriptions
                  label-placement="left"
                  :column="2"
                  size="small"
                  bordered
                >
                  <n-descriptions-item
                    label="결제계좌"
                    label-placement="left"
                    style="text-align: right"
                    labelStyle="width:100px;"
                    contentStyle="text-align: center; ;align-content: center;"
                  >
                    {{ formModel.payment_method.bank_name || "N/A" }}
                  </n-descriptions-item>
                  <n-descriptions-item
                    label="입금예정일"
                    label-placement="left"
                    labelStyle="width:100px"
                  >
                    <n-form-item
                      path="payment_method.bank_date"
                      :show-label="false"
                      style="margin-bottom: 0"
                    >
                      <n-date-picker
                        v-model:formatted-value="
                          formModel.payment_method.bank_date
                        "
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="입금 예정일 선택"
                        style="width: 100%"
                      />
                    </n-form-item>
                  </n-descriptions-item>
                </n-descriptions>
              </n-card>

              <div
                style="text-align: right; margin-top: 24px; margin-bottom: 20px"
              >
                <n-button
                  type="tertiary"
                  @click="handleCancelEdit"
                  style="margin-right: 12px"
                >
                  취소하기
                </n-button>
                <n-button
                  type="primary"
                  @click="handleSubmitOrder"
                  :loading="submitLoading"
                  style="min-width: 150px"
                >
                  견적서 수정하기
                </n-button>
                <n-button
                  type="error"
                  ghost
                  @click="deleteCurrentOrder(formModel.SK)"
                  :disabled="!formModel.SK"
                  style="margin-left: 12px"
                >
                  견적 삭제
                </n-button>
              </div>
            </n-form>
          </div>
        </NCard>
      </n-space>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  NDataTable,
  NSpace,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NButton,
  NInputNumber,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadio,
  NCheckboxGroup,
  NCheckbox,
  NGrid,
  NGi,
  FormInst,
  FormRules,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable } from "@/config/env";
import { useOrderForm, useOrderApi } from "@/composables/useOrderForm";
import { OrganizationType } from "@/model/organization"; // 추가
import { USER_ROUTES } from "@/assets/route_constants";
import * as common from "@/assets/common/common"; // 추가

const componentKey = ref(0);
const router = useRouter();
const route = useRoute();
const getCallApiCallable = getCallable("callApi");
const {
  pageLoading,
  submitLoading,
  requestFormRef,
  formModel,

  orgType,
  selectedOrgType,
  surveySet,
  coachSet,
  selectedCoachSKsForBoth,
  totalPrice,

  isUniversity,
  newFormRules,
  editFormRules,

  handleSubmitOrder,
  handleCancelEdit,
  setupForm,
} = useOrderForm({
  isEdit: true,
  orderSK: route.params.SK as string,
  cancelRouteName: USER_ROUTES.OrgOrder.Name,
  onSuccessNotificationTitle: "Order",
  onSuccessRedirect: USER_ROUTES.OrgOrder.Name,
  onErrorNotificationTitle: "견적서 수정 실패",
  submissionCallable: getCallApiCallable,
});
const { deleteOrder } = useOrderApi();
function deleteCurrentOrder(orderSK: string) {
  deleteOrder(orderSK).then((success) => {
    if (success) {
      router.push({ name: USER_ROUTES.OrgOrder.Name });
    }
  });
}
onMounted(async () => {
  await setupForm();
});
</script>

<style scoped>
::v-deep(.n-input input) {
  text-decoration: none !important;
  color: #000;
}

.main_div {
  background-color: #f0f2f5;
  min-height: calc(100vh - var(--header-height, 64px));
  padding: 1px; /* 자식 마진 병합 방지 */
}

.content_delimiter_line {
  height: 1px;
  width: 100%;
  background-color: #efeff5;
  margin-top: 15px;
  margin-bottom: 25px;
}

.body_content {
  padding: 0 10px; /* 내부 컨텐츠 좌우 약간의 패딩 */
}

:deep(.n-card-header__main) {
  text-align: left;
}
:deep(.n-descriptions-header) {
  text-align: left;
  font-size: 15px !important; /* 원하는 크기로 조절 */
}
:deep(.n-descriptions-table-content) {
  text-align: left;
  align-content: center;
}
.product-request-item {
  /* OrderRegister.vue 스타일 */
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #f9f9f9;
}
.total-unit_price-section {
  /* OrderRegister.vue 스타일 */
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}
:deep(.n-form-item-feedback-wrapper:empty) {
  display: none;
}
:deep(.n-card-header__main) {
  text-align: left;
}

:deep(.n-descriptions-header) {
  text-align: left;
  font-size: 15px !important; /* 원하는 크기로 조절 */
}
:deep(.n-descriptions-table-content) {
  text-align: left;
  align-content: center;
}
</style>
